import api from "@/services/api/api-payment"
export default class PaymentRepo {
  async list() {
    return await api.list()
  }

  async create(data) {
    return await api.create(data)
  }

  async cancel(ID) {
    return await api.cancel(ID)
  }
}